module.exports = __webpack_public_path__ + "static/img/9.cb84490.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/9.png
// module id = 205
// module chunks = 1